import { render, staticRenderFns } from "./TrialBanner.vue?vue&type=template&id=1af1028c&"
import script from "./TrialBanner.vue?vue&type=script&lang=js&"
export * from "./TrialBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1af1028c')) {
      api.createRecord('1af1028c', component.options)
    } else {
      api.reload('1af1028c', component.options)
    }
    module.hot.accept("./TrialBanner.vue?vue&type=template&id=1af1028c&", function () {
      api.rerender('1af1028c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/app/TrialBanner.vue"
export default component.exports